export const getCKEditorPlugins = (CKEditor: any, CKEditorPremiumFeatures: any) => {
  const {
    ClassicEditor,
    Alignment,
    Autoformat,
    AutoImage,
    AutoLink,
    Autosave,
    BalloonToolbar,
    BlockQuote,
    BlockToolbar,
    Bold,
    Bookmark,
    /* CKBox, CKBoxImageEdit, */ CloudServices,
    Code,
    Emoji,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    Fullscreen,
    GeneralHtmlSupport,
    Heading,
    Highlight,
    HorizontalLine,
    ImageBlock,
    ImageCaption,
    ImageEditing,
    ImageInline,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    ImageUtils,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    Mention,
    PageBreak,
    Paragraph,
    PasteFromOffice,
    PictureEditing,
    RemoveFormat,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    Strikethrough,
    Style,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
  } = CKEditor;

  // Handle premium features - they might be undefined in free version
  const premiumFeatures = CKEditorPremiumFeatures || {};
  const {
    CaseChange,
    ExportPdf,
    ExportWord,
    FormatPainter,
    ImportWord,
    LineHeight,
    MergeFields,
    MultiLevelList,
    PasteFromOfficeEnhanced,
    SlashCommand,
    TableOfContents,
    Template,
  } = premiumFeatures;

  // Filter out undefined premium features
  const plugins = [
    Alignment,
    Autoformat,
    AutoImage,
    AutoLink,
    Autosave,
    BalloonToolbar,
    BlockQuote,
    BlockToolbar,
    Bold,
    Bookmark,
    // CKBox, CKBoxImageEdit, // excluded to avoid unauthorized CKBox calls
    CloudServices,
    Code,
    Emoji,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    Fullscreen,
    GeneralHtmlSupport,
    Heading,
    Highlight,
    HorizontalLine,
    ImageBlock,
    ImageCaption,
    ImageEditing,
    ImageInline,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    ImageUtils,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    Mention,
    PageBreak,
    Paragraph,
    PasteFromOffice,
    PictureEditing,
    RemoveFormat,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    Strikethrough,
    Style,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
  ];

  // Add premium features only if they exist
  if (CaseChange) plugins.push(CaseChange);
  if (ExportPdf) plugins.push(ExportPdf);
  if (ExportWord) plugins.push(ExportWord);
  if (FormatPainter) plugins.push(FormatPainter);
  if (ImportWord) plugins.push(ImportWord);
  if (LineHeight) plugins.push(LineHeight);
  if (MergeFields) plugins.push(MergeFields);
  if (MultiLevelList) plugins.push(MultiLevelList);
  if (PasteFromOfficeEnhanced) plugins.push(PasteFromOfficeEnhanced);
  if (SlashCommand) plugins.push(SlashCommand);
  if (TableOfContents) plugins.push(TableOfContents);
  if (Template) plugins.push(Template);

  // return plugins.filter(plugin => plugin !== undefined);
  return plugins;
};
